import React from 'react';
import { t } from '../../../../modules/infra/i18n';
import SearchHeader from '../../../main/headers/searchHeader';
import ShopList from '../containers/ShopList';

const Shops = () => (
  <div>
    <SearchHeader
      heading={t('admin:shops.header')}
      type="shop"
      button={t('admin:shops.add_button')}
      link="/admin/shops/add"
      admin
    />
    <div className="c-wrapper o-page-height">
      <ShopList />
    </div>
  </div>
);

export default Shops;
